import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import {
  GetStreamActivities,
  ActivityStreamEvent,
  ClearActivityStreamStore,
  GetStreamActivityTypes, RemoveActivityById,
} from 'ng2-app/store/activity/activity.actions';
import { ActivityService }  from 'ng2-app/modules/activity/models/activity/activity.service';
import { insertItem, patch, removeItem } from '@ngxs/store/operators';
import { ChecklistOption } from 'ng2-app/components/checklist/checklist.component';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { sortBy } from 'lodash';


export class ActivityStreamStateModel {
  loading: boolean;
  activities: Activity[];
  activityTypes: ChecklistOption[];
}

@Injectable()
@State<ActivityStreamStateModel>({
  name: 'activityStream',
  defaults: {
    loading: false,
    activities: [],
    activityTypes: [],
  },
})

export class ActivityStreamState {
  @Selector()
  static activities(state: ActivityStreamStateModel) {
    return state.activities;
  }

  @Selector()
  static activityTypes(state: ActivityStreamStateModel) {
    return state.activityTypes;
  }

  @Selector()
  static loading(state: ActivityStreamStateModel) {
    return state.loading;
  }

  constructor(
    private activityService: ActivityService,
  ) {}

  @Action(GetStreamActivityTypes)
  GetStreamActivityTypes(
    ctx: StateContext<ActivityStreamStateModel>,
    { params }: GetStreamActivityTypes,
  ) {
    return this.activityService.getActivityTypes(params).then( types => {
      const activityTypes = sortBy(
        types.map( type => ({ label: type.name, value: type.id, selected: false }) ),
        'label'
      );
      ctx.patchState({
        activityTypes,
      });
    });
  }

  @Action(GetStreamActivities)
  getStreamActivities(
    { getState, patchState }: StateContext<ActivityStreamStateModel>,
    { criteria, limit, offset, reset }: GetStreamActivities,
  ) {
    const sort = {'activities.created': 'DESC'},
      current = getState().activities;
    const prePatch: any = {
      loading: true,
    };
    if(reset) {
      prePatch.activities = [];
    }
    patchState(prePatch);
    this.activityService.getAll({
      query: {
        criteria,
        limit,
        offset,
        sort,
      }
    }).subscribe( activities => {

      const newActivities = reset
        ? activities
        : [...current, ...activities];

      patchState({
        activities: newActivities,
        loading: false,
      });

    });

  }

  @Action(ActivityStreamEvent)
  newActivityEvent(
    { setState }: StateContext<ActivityStreamStateModel>,
    { activity }: ActivityStreamEvent
  ) {
    const contextFn = (curAct: Activity) => curAct.id === activity.id;
    const activities = activity.deletedTimestamp
      ? removeItem<Activity>(contextFn)
      : insertItem<Activity>(activity);

    setState(patch({
      activities
    }));
  }

  @Action(ClearActivityStreamStore)
  clearActivityStreamStore(
    { patchState }: StateContext<ActivityStreamStateModel>,
    { }: ClearActivityStreamStore
  ) {
    patchState({
      activities: [],
      activityTypes: [],
    });
  }

  @Action(RemoveActivityById)
  RemoveActivityById(
    ctx: StateContext<ActivityStreamStateModel>,
    { activityId }: RemoveActivityById,
  ) {
    ctx.setState(patch({
      activities: removeItem( activity => activity.id === activityId ),
    }));
  }
}
